import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthProvider"
import { useEffect } from "react"
import { NavLink } from "react-router-dom"

export function MeuPerfilPage() {
    const { usuario } = useAuth()
    useEffect(() => {

    }, [])


    return (
        <div className="flex flex-col gap-4 mx-2 my-5">
            <h1 className="text-primary-foreground text-2xl uppercase font-black">Meu Perfil</h1>
            <div className="flex flex-col">
                <p>Nome: <span className="font-bold">{usuario?.Nome}</span></p>
                <p>CPF: <span className="font-bold">{usuario?.CPF}</span></p>
                <p>Telefone: <span className="font-bold">{usuario?.Telefone}</span></p>
                <p>E-mail: <span className="font-bold">{usuario?.Email}</span></p>
                <p>Endereço: <span className="font-bold">{`${usuario?.Endereco.Logradouro}${usuario?.Endereco.Numero ? (' - ' + usuario.Endereco.Numero) : ''}, ${usuario?.Endereco.Cidade} - ${usuario?.Endereco.UF}`}</span></p>
            </div>
            <div className="flex justify-end gap-3">
                <NavLink to="/perfil/editar">
                    <Button>Editar Cadastro</Button>
                </NavLink>
                <NavLink to="/alterarsenha">
                    <Button>Alterar Senha</Button>
                </NavLink>
            </div>
        </div>
    )
}